// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/governance/v0/employee_personal_data.proto (package squareup.governance.v0, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/common/governance/v0/employee_personal_data.proto.
 */
export const file_squareup_common_governance_v0_employee_personal_data: GenFile = /*@__PURE__*/
  fileDesc("CjpzcXVhcmV1cC9jb21tb24vZ292ZXJuYW5jZS92MC9lbXBsb3llZV9wZXJzb25hbF9kYXRhLnByb3RvEhZzcXVhcmV1cC5nb3Zlcm5hbmNlLnYwIqMKChRFbXBsb3llZVBlcnNvbmFsRGF0YSKKCgoMU2VtYW50aWNUeXBlEg4KCkRPX05PVF9VU0UQABIXChNHT1ZfSURfRkFDSUFMX0lNQUdFEAESEAoMRklOR0VSUFJJTlRTEAISDwoLSEFORFdSSVRJTkcQAxIaChZQRVJTT05BTF9FTUFJTF9BRERSRVNTEAQSFwoTUkVTSURFTlRJQUxfQUREUkVTUxAFEhkKFVBFUlNPTkFMX1BIT05FX05VTUJFUhAGEhUKEVBFUlNPTkFMX1VTRVJOQU1FEAcSFwoTQkFOS19BQ0NPVU5UX05VTUJFUhAIEhkKFUlNTUlHUkFUSU9OX0lEX05VTUJFUhAJEgcKA1NTThAKEhMKD1BBU1NQT1JUX05VTUJFUhALEhoKFkRSSVZFUlNfTElDRU5TRV9OVU1CRVIQDBIICgRJVElOEA0SGAoUR0VORVJJQ19GQUNJQUxfSU1BR0UQDhIICgROQU1FEA8SFgoSV09SS19FTUFJTF9BRERSRVNTEBASFQoRV09SS19QSE9ORV9OVU1CRVIQERIRCg1XT1JLX1VTRVJOQU1FEBISDwoLRU1QTE9ZRUVfSUQQExIOCgpBVVRIX1RPS0VOEBQSDAoIUEFTU1dPUkQQFRIXChNTVFJFRVRfT0ZfUkVTSURFTkNFEBYSHAoYUE9TVEFMX0NPREVfT0ZfUkVTSURFTkNFEBcSFQoRQ0lUWV9PRl9SRVNJREVOQ0UQGBIXChNSRUdJT05fT0ZfUkVTSURFTkNFEBkSGAoUQ09VTlRSWV9PRl9SRVNJREVOQ0UQGhINCglERVZJQ0VfSUQQGxIKCgZHRU5ERVIQHBIRCg1EQVRFX09GX0JJUlRIEB0SFgoSQklSVEhfREFZX09GX01PTlRIEB4SDwoLQklSVEhfTU9OVEgQHxIOCgpCSVJUSF9ZRUFSECASBwoDQUdFECESDwoLQ0lUSVpFTlNISVAQIhINCglKT0JfVElUTEUQIxIRCg1PUkdfUExBQ0VNRU5UECQSEQoNV09SS19MT0NBVElPThAlEhQKEEVNUExPWU1FTlRfREFURVMQJhIOCgpERVBFTkRFTlRTECcSFQoRRU1FUkdFTkNZX0NPTlRBQ1QQKBINCglFRFVDQVRJT04QKRIWChJFTVBMT1lNRU5UX0hJU1RPUlkQKhISCg5DQU5ESURBVEVfREFUQRArEhAKDE1FRElDQUxfSU5GTxAsEhQKEENSSU1JTkFMX0hJU1RPUlkQLRIRCg1MRUdBTF9ISVNUT1JZEC4SFAoQQkFDS0dST1VORF9DSEVDSxAvEhMKD0pPQl9QRVJGT1JNQU5DRRAwEhwKGExFQVJOSU5HX0FORF9ERVZFTE9QTUVOVBAxEhQKEEVYVFJBQ1VSUklDVUxBUlMQMhINCglCQU5LX05BTUUQMxIXChNCQU5LX1JPVVRJTkdfTlVNQkVSEDQSHgoaQ09BUlNFX0JBTktfQUNDT1VOVF9OVU1CRVIQNRIQCgxDUkVESVRfU0NPUkUQNhIRCg1QQVlTTElQX0RBVEVTEDcSFwoTUEFZUk9MTF9JTkZPUk1BVElPThA4Eg4KClRJTUVTSEVFVFMQORIQCgxDT01QRU5TQVRJT04QOhITCg9UQVhfSU5GT1JNQVRJT04QOxIOCgpDT0FSU0VfU1NOEDwSDgoKSVBfQUREUkVTUxA9EhQKEFNZU1RFTV9VU0FHRV9MT0cQPkIqCihjb20uc3F1YXJldXAucHJvdG9zLmNvbW1vbi5nb3Zlcm5hbmNlLnYw");

/**
 * @generated from message squareup.governance.v0.EmployeePersonalData
 */
export type EmployeePersonalData = Message<"squareup.governance.v0.EmployeePersonalData"> & {
};

/**
 * Describes the message squareup.governance.v0.EmployeePersonalData.
 * Use `create(EmployeePersonalDataSchema)` to create a new message.
 */
export const EmployeePersonalDataSchema: GenMessage<EmployeePersonalData> = /*@__PURE__*/
  messageDesc(file_squareup_common_governance_v0_employee_personal_data, 0);

/**
 * @generated from enum squareup.governance.v0.EmployeePersonalData.SemanticType
 */
export enum EmployeePersonalData_SemanticType {
  /**
   * @generated from enum value: DO_NOT_USE = 0;
   */
  DO_NOT_USE = 0,

  /**
   * Facial images used for identity verification, such as on a photo of a Government ID document. Note: This does not include facial images used on company ID badges or for employee profiles on Block systems, e.g. org charts, or photographs and videos used in other contexts. (See GENERIC_FACIAL_IMAGE instead.)
   *
   * @generated from enum value: GOV_ID_FACIAL_IMAGE = 1;
   */
  GOV_ID_FACIAL_IMAGE = 1,

  /**
   * Fingerprints.
   *
   * @generated from enum value: FINGERPRINTS = 2;
   */
  FINGERPRINTS = 2,

  /**
   * Handwriting, including a handwritten signature, such as on a photo of a Government ID document.
   *
   * @generated from enum value: HANDWRITING = 3;
   */
  HANDWRITING = 3,

  /**
   * Personal email address (including hashed email address)
   *
   * @generated from enum value: PERSONAL_EMAIL_ADDRESS = 4;
   */
  PERSONAL_EMAIL_ADDRESS = 4,

  /**
   * Residential postal address.
   *
   * @generated from enum value: RESIDENTIAL_ADDRESS = 5;
   */
  RESIDENTIAL_ADDRESS = 5,

  /**
   * Personal phone number (including hashed phone number).
   *
   * @generated from enum value: PERSONAL_PHONE_NUMBER = 6;
   */
  PERSONAL_PHONE_NUMBER = 6,

  /**
   * Usernames or social media handles.
   *
   * @generated from enum value: PERSONAL_USERNAME = 7;
   */
  PERSONAL_USERNAME = 7,

  /**
   * Bank account number.
   *
   * @generated from enum value: BANK_ACCOUNT_NUMBER = 8;
   */
  BANK_ACCOUNT_NUMBER = 8,

  /**
   * Immigration related identification numbers including visa case numbers, Permanent Resident Card (Green Card) numbers, etc.
   *
   * @generated from enum value: IMMIGRATION_ID_NUMBER = 9;
   */
  IMMIGRATION_ID_NUMBER = 9,

  /**
   * Social Security Number (SSN).
   *
   * @generated from enum value: SSN = 10;
   */
  SSN = 10,

  /**
   * Passport Number.
   *
   * @generated from enum value: PASSPORT_NUMBER = 11;
   */
  PASSPORT_NUMBER = 11,

  /**
   * Driver's License Number.
   *
   * @generated from enum value: DRIVERS_LICENSE_NUMBER = 12;
   */
  DRIVERS_LICENSE_NUMBER = 12,

  /**
   * Individual Tax ID Number (ITIN).
   *
   * @generated from enum value: ITIN = 13;
   */
  ITIN = 13,

  /**
   * Facial images used on company ID badges or for employee profiles on Block systems (e.g. org charts).
   *
   * @generated from enum value: GENERIC_FACIAL_IMAGE = 14;
   */
  GENERIC_FACIAL_IMAGE = 14,

  /**
   * Personal name (first name, last name, middle name, full name, etc.).
   *
   * @generated from enum value: NAME = 15;
   */
  NAME = 15,

  /**
   * Work email address.
   *
   * @generated from enum value: WORK_EMAIL_ADDRESS = 16;
   */
  WORK_EMAIL_ADDRESS = 16,

  /**
   * Work phone number.
   *
   * @generated from enum value: WORK_PHONE_NUMBER = 17;
   */
  WORK_PHONE_NUMBER = 17,

  /**
   * Username (for access to Block systems).
   *
   * @generated from enum value: WORK_USERNAME = 18;
   */
  WORK_USERNAME = 18,

  /**
   * Employee ID.
   *
   * @generated from enum value: EMPLOYEE_ID = 19;
   */
  EMPLOYEE_ID = 19,

  /**
   * Authentication tokens and session tokens such as Block SSO tokens.
   *
   * @generated from enum value: AUTH_TOKEN = 20;
   */
  AUTH_TOKEN = 20,

  /**
   * Employee password (e.g. employee password, employee/job candidate PIN).
   *
   * @generated from enum value: PASSWORD = 21;
   */
  PASSWORD = 21,

  /**
   * The street name and street number of an employee's residence, including any additional information about unit/apt/suite/etc.
   *
   * @generated from enum value: STREET_OF_RESIDENCE = 22;
   */
  STREET_OF_RESIDENCE = 22,

  /**
   * Residential ZIP/postal code
   *
   * @generated from enum value: POSTAL_CODE_OF_RESIDENCE = 23;
   */
  POSTAL_CODE_OF_RESIDENCE = 23,

  /**
   * City of residence
   *
   * @generated from enum value: CITY_OF_RESIDENCE = 24;
   */
  CITY_OF_RESIDENCE = 24,

  /**
   * State/Region/Province/County of residence
   *
   * @generated from enum value: REGION_OF_RESIDENCE = 25;
   */
  REGION_OF_RESIDENCE = 25,

  /**
   * Country of residence (e.g. Customer Region/Country Code).
   *
   * @generated from enum value: COUNTRY_OF_RESIDENCE = 26;
   */
  COUNTRY_OF_RESIDENCE = 26,

  /**
   * Device IDs (including unique identifiers that correspond with an individual's mobile device or computer).
   *
   * @generated from enum value: DEVICE_ID = 27;
   */
  DEVICE_ID = 27,

  /**
   * Gender.
   *
   * @generated from enum value: GENDER = 28;
   */
  GENDER = 28,

  /**
   * Precise Date of Birth (DOB).
   *
   * @generated from enum value: DATE_OF_BIRTH = 29;
   */
  DATE_OF_BIRTH = 29,

  /**
   * The day of the month that an employee was born.
   *
   * @generated from enum value: BIRTH_DAY_OF_MONTH = 30;
   */
  BIRTH_DAY_OF_MONTH = 30,

  /**
   * The month an employee was born.
   *
   * @generated from enum value: BIRTH_MONTH = 31;
   */
  BIRTH_MONTH = 31,

  /**
   * The year an employee was born.
   *
   * @generated from enum value: BIRTH_YEAR = 32;
   */
  BIRTH_YEAR = 32,

  /**
   * An employee's age.
   *
   * @generated from enum value: AGE = 33;
   */
  AGE = 33,

  /**
   * Citizenship.
   *
   * @generated from enum value: CITIZENSHIP = 34;
   */
  CITIZENSHIP = 34,

  /**
   * Job Title.
   *
   * @generated from enum value: JOB_TITLE = 35;
   */
  JOB_TITLE = 35,

  /**
   * Business Unit/Division/Department.
   *
   * @generated from enum value: ORG_PLACEMENT = 36;
   */
  ORG_PLACEMENT = 36,

  /**
   * Physical Work Location.
   *
   * @generated from enum value: WORK_LOCATION = 37;
   */
  WORK_LOCATION = 37,

  /**
   * Hire Date/Termination Date.
   *
   * @generated from enum value: EMPLOYMENT_DATES = 38;
   */
  EMPLOYMENT_DATES = 38,

  /**
   * Details of dependents.
   *
   * @generated from enum value: DEPENDENTS = 39;
   */
  DEPENDENTS = 39,

  /**
   * Emergency Contact Details.
   *
   * @generated from enum value: EMERGENCY_CONTACT = 40;
   */
  EMERGENCY_CONTACT = 40,

  /**
   * Education History including licenses, certifications, and qualifications.
   *
   * @generated from enum value: EDUCATION = 41;
   */
  EDUCATION = 41,

  /**
   * Employement History.
   *
   * @generated from enum value: EMPLOYMENT_HISTORY = 42;
   */
  EMPLOYMENT_HISTORY = 42,

  /**
   * Job candidate support data, such as: Replies to job opening, feedback sent to applicants, interview records, references and referrals.
   *
   * @generated from enum value: CANDIDATE_DATA = 43;
   */
  CANDIDATE_DATA = 43,

  /**
   * Medical Information (physical or mental health or condition).
   *
   * @generated from enum value: MEDICAL_INFO = 44;
   */
  MEDICAL_INFO = 44,

  /**
   * Criminal History.
   *
   * @generated from enum value: CRIMINAL_HISTORY = 45;
   */
  CRIMINAL_HISTORY = 45,

  /**
   * Any commissioned offense, civil proceeding or sentencing.
   *
   * @generated from enum value: LEGAL_HISTORY = 46;
   */
  LEGAL_HISTORY = 46,

  /**
   * Information pertaining to background screens including OFAC screens.
   *
   * @generated from enum value: BACKGROUND_CHECK = 47;
   */
  BACKGROUND_CHECK = 47,

  /**
   * Job Performance Information.
   *
   * @generated from enum value: JOB_PERFORMANCE = 48;
   */
  JOB_PERFORMANCE = 48,

  /**
   * Block-sponsored or mandated Training and Development History.
   *
   * @generated from enum value: LEARNING_AND_DEVELOPMENT = 49;
   */
  LEARNING_AND_DEVELOPMENT = 49,

  /**
   * Involvement in extracurricular activities including such as running clubs or Block communities.
   *
   * @generated from enum value: EXTRACURRICULARS = 50;
   */
  EXTRACURRICULARS = 50,

  /**
   * Bank name.
   *
   * @generated from enum value: BANK_NAME = 51;
   */
  BANK_NAME = 51,

  /**
   * Bank routing number.
   *
   * @generated from enum value: BANK_ROUTING_NUMBER = 52;
   */
  BANK_ROUTING_NUMBER = 52,

  /**
   * Bank account number (coarse): maximum of four (4) digits.
   *
   * @generated from enum value: COARSE_BANK_ACCOUNT_NUMBER = 53;
   */
  COARSE_BANK_ACCOUNT_NUMBER = 53,

  /**
   * Credit scores (e.g., FICO).
   *
   * @generated from enum value: CREDIT_SCORE = 54;
   */
  CREDIT_SCORE = 54,

  /**
   * Payslip dates and time deposited to bank accounts.
   *
   * @generated from enum value: PAYSLIP_DATES = 55;
   */
  PAYSLIP_DATES = 55,

  /**
   * Payroll information.
   *
   * @generated from enum value: PAYROLL_INFORMATION = 56;
   */
  PAYROLL_INFORMATION = 56,

  /**
   * Work Schedule and time card information.
   *
   * @generated from enum value: TIMESHEETS = 57;
   */
  TIMESHEETS = 57,

  /**
   * Information relating to an employee's income, 401K, equities, and any other parts of an employee's compensation package.
   *
   * @generated from enum value: COMPENSATION = 58;
   */
  COMPENSATION = 58,

  /**
   * Tax Information such as withdrawing allowances, tax filing status, and marital status.
   *
   * @generated from enum value: TAX_INFORMATION = 59;
   */
  TAX_INFORMATION = 59,

  /**
   * Last four (4) digits of Social Security Number (SSN).
   *
   * @generated from enum value: COARSE_SSN = 60;
   */
  COARSE_SSN = 60,

  /**
   * IP Address.
   *
   * @generated from enum value: IP_ADDRESS = 61;
   */
  IP_ADDRESS = 61,

  /**
   * Device, log file and other information relating to an individual's use of Block systems, services and/or devices, and information about a user device's interaction with Block systems/services.  This includes information collected via cookies and web beacons, like web browser and device characteristics, pixel tags.
   *
   * @generated from enum value: SYSTEM_USAGE_LOG = 62;
   */
  SYSTEM_USAGE_LOG = 62,
}

/**
 * Describes the enum squareup.governance.v0.EmployeePersonalData.SemanticType.
 */
export const EmployeePersonalData_SemanticTypeSchema: GenEnum<EmployeePersonalData_SemanticType> = /*@__PURE__*/
  enumDesc(file_squareup_common_governance_v0_employee_personal_data, 0, 0);

